<style>
    h1 {
        text-transform: capitalize;
    }
</style>
<template>
    <div class="main-content">
        <section class="section">
          <div class="section-header">
            <h1>Transaksi {{ jenis_transaksi }} {{ tipe_transaksi }}</h1>
            <div class="section-header-breadcumb button">
                <button v-if="transaksiDetail.detail.tipe_transaksi == 'pemesanan' || transaksiDetail.detail.tipe_transaksi == 'packing'" class="btn btn-outline-danger" style="margin-right:5px" @click="deleteTransaksi(id_transaksi)"> <i class="fa fa-trash"></i> Delete Transaksi</button>
                <button v-if="transaksiDetail.detail.status_progress == 'pengiriman' || transaksiDetail.detail.status_progress == 'faktur'" class="btn btn-outline-danger" style="margin-right:5px" @click="deleteTransaksiProgress(id_transaksi)"> <i class="fa fa-trash"></i> Delete Transaksi</button>
                <a v-if="transaksiDetail.detail.tipe_transaksi == 'packing'" href="javascript:" @click.prevent="goTo('/penjualan/create-packing-transaksi/'+id_transaksi)" class="btn btn-icon icon-left btn-outline-primary" style="margin-right:5px;"><i class="fas fa-box-open"></i> Packing Pengiriman</a>
                <a v-if="transaksiDetail.detail.tipe_transaksi == 'pemesanan'" href="javascript:" @click.prevent="goTo('/penjualan/edit-transaksi/'+id_transaksi)" class="btn btn-icon icon-left btn-outline-primary" style="margin-right:5px;"><i class="fa fa-edit"></i> Edit Transaksi</a>
                <a v-if="transaksiDetail.detail.nomor_pengiriman != null" :href="siteUrl+'Transaksi/getSuratJalanProgress/'+id_transaksi" target="_blank" class="btn btn-icon icon-left btn-light" style="margin-right:5px;"><i class="fas fa-truck"></i> Cetak Surat Jalan</a>
                <a v-if="transaksiDetail.detail.nomor_invoice != null" href="javascript:" @click.prevent="goTo('/penjualan/print-invoice/'+id_transaksi)" class="btn btn-icon icon-left btn-primary"><i class="fas fa-file"></i> Cetak Invoice</a>
            </div>
          </div>
        <div class="section-body">
            <h2 class="section-title">Harga Total : Rp. {{ currencyFormat(transaksiDetail.detail.total_harga) }}</h2>
            <p class="section-lead">Dibayar : Rp. {{ currencyFormat(transaksiDetail.detail.dibayar) }} </p>

            <div class="row">
                <div class="col-12 col-md-4 col-lg-4">
                    <div class="card">
                        <div class="card-header">
                            <h4>Informasi Supplier</h4>
                        </div>
                        <div class="card-body">
                            <table class="table table-hover">
                                <tbody>
                                    <tr>
                                        <th style="width:50%;">
                                            Supplier
                                        </th>
                                        <td>
                                            {{ transaksiDetail.detail.display_name }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            Email
                                        </th>
                                        <td>
                                            {{ transaksiDetail.detail.email_transaksi }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            Alamat Supplier
                                        </th>
                                        <td>
                                            ({{ transaksiDetail.detail.alamat_transaksi }})
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="card-footer">

                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-4 col-lg-4">
                    <div class="card">
                        <div class="card-header">
                            <h4>Informasi Transaksi</h4>
                        </div>
                        <div class="card-body">
                            <table class="table table-hover">
                                <tbody>
                                    <tr>
                                        <th style="width:50%;">
                                            Nomor Transaksi
                                        </th>
                                        <td>
                                            {{ transaksiDetail.detail.nomor_transaksi }}
                                        </td>
                                    </tr>
                                    <tr v-if="transaksiDetail.detail.nomor_pengiriman != null">
                                        <th>
                                            Nomor Surat Jalan
                                        </th>
                                        <td>
                                            {{ transaksiDetail.detail.nomor_pengiriman }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            Tgl Transaksi
                                        </th>
                                        <td>
                                            {{ transaksiDetail.detail.tanggal_transaksi | moment("DD MMMM YYYY") }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            Tgl Jatuh Tempo
                                        </th>
                                        <td>
                                            {{ transaksiDetail.detail.tanggal_jatuh_tempo | moment("DD MMMM YYYY") }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-4 col-lg-4">
                    <div class="card">
                        <div class="card-header">
                            <h4>Informasi Tambahan</h4>
                        </div>
                        <div class="card-body">
                            <table class="table table-hover">
                                <tbody>
                                    <tr>
                                        <th style="width:50%;">
                                            Pesan
                                        </th>
                                        <td>
                                            {{ transaksiDetail.detail.pesan }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            Memo
                                        </th>
                                        <td>
                                            {{ transaksiDetail.detail.memo }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="card-footer">

                        </div>
                    </div>
                </div>

                <div class="col-12">
                    <div class="card">
                        <div class="card-header">
                            <h4>Daftar Produk</h4>
                        </div>
                        <div class="card-body">
                            <div class="table-responsive">
                                <table class="table table-striped">
                                    <tr>
                                        <th>Produk</th>
                                        <th v-if="url != 'pemesanan-penjualan' && url != 'packing-penjualan'">
                                            Packaging
                                        </th>
                                        <th>Kuantitas Dipesan</th>
                                        <th v-if="url != 'pemesanan-penjualan'">Kuantitas Dikirim</th>
                                        <th v-if="url != 'pemesanan-penjualan' && url != 'packing-penjualan'">
                                            Kemasan
                                        </th>
                                        <th v-else>
                                            Kuantitas Tersedia
                                        </th>
                                        <th v-if="url != 'pemesanan-penjualan' && url != 'packing-penjualan'">
                                            Action
                                        </th>
                                        <th v-if="setPengiriman" >Status Packing </th>
                                        <th v-if="done == true">Harga Satuan ($) </th>
                                        <th v-if="done == true">Harga Satuan (IDR) </th>
                                        <th v-if="done == true">Jumlah ($)</th>
                                        <th v-if="done == true">Jumlah (IDR)</th>
                                        <th></th>
                                        <th></th>
                                    </tr>
                                    <tbody v-if="bodyRender">
                                        <tr v-for="(data,index) in transaksiDetail.produkList" v-bind:key="index">
                                            <td>
                                            {{ data.transaksi_nama_produk }}
                                            </td>
                                            <td v-if="url != 'pemesanan-penjualan' && url != 'packing-penjualan'">
                                                {{ data.qty_send/ (data.qty_package == null ? 1 : data.qty_package ) }} {{ data.nama_satuan }}
                                            </td>
                                            <td>
                                                {{ data.qty }} {{ data.nama_satuan }}
                                            </td>
                                            <td v-if="url != 'pemesanan-penjualan'">
                                                {{ data.qty_send }} {{ data.nama_satuan }}
                                            </td>
                                            <td v-if="url != 'pemesanan-penjualan' && url != 'packing-penjualan'">
                                                {{ data.nama_produk_package }}
                                            </td>
                                            <td v-else>
                                                {{ data.qty_total }} {{ data.nama_satuan }}
                                            </td>
                                            <td v-if="url != 'pemesanan-penjualan' && url != 'packing-penjualan'">
                                                <button class="btn btn-warning" @click="returnItem(data.id_transaksi_produk,data.id_transaksi_progress)"><i class="fa fa-undo"></i> Return</button>
                                            </td>
                                            <td v-if="setPengiriman == true">
                                                <span v-html="statusPackCallback(data.all_packed)">  </span>
                                            </td>
                                            <td v-if="done == true">
                                                $. {{ currencyFormat(data.harga_satuan) }}
                                            </td>
                                            <td v-if="done == true">
                                                Rp. {{ currencyFormat(data.harga_satuan_idr) }}
                                            </td>
                                            <td v-if="done == true">
                                                $. {{ currencyFormat(data.harga_total) }}
                                            </td>
                                            <td v-if="done == true">
                                                Rp. {{ currencyFormat(data.harga_total_idr) }}
                                            </td>
                                            <!-- <td>
                                                Rp. {{ currencyFormat(data.harga_satuan) }}
                                            </td>
                                            <td>
                                                Rp. {{ currencyFormat(data.harga_total) }}
                                            </td> -->
                                            <td>
                                                <input v-if="data.is_produksi == 1 && setPengiriman" :max="data.kapabilitas" min="0" type="number" class="form-control" v-model="data.qty_produce" :placeholder="'Kapabilitas : '+data.kapabilitas">
                                            </td>
                                            <td>
                                                <button v-if="data.is_produksi == 1 && setPengiriman" class="btn btn-primary" @click="produce(index)"> <i class="fas fa-flask"></i> Produce</button>
                                            </td>
                                        </tr>

                                        <!-- <tr v-if="done">
                                            <th colspan="5" style="text-align:right">Pajak</th>
                                            <td>
                                                {{ this.transaksiDetail.detail.pajak }} %
                                            </td>
                                            <td>&nbsp;</td>
                                            <th>&nbsp;</th>
                                        </tr>
                                        <tr v-if="done">
                                            <th style="text-align:right" colspan="5">Total Tagihan</th>
                                            <th>USD {{ currencyFormat(transaksiDetail.detail.total_harga) }}</th>
                                            <th>IDR {{ currencyFormat(transaksiDetail.detail.total_harga * transaksiDetail.detail.kurs_usd) }} </th>
                                            <th>&nbsp;</th>
                                        </tr>
                                        <tr v-if="done">
                                            <th colspan="5" style="text-align:right">Dibayar</th>
                                            <td>
                                                USD {{ currencyFormat(transaksiDetail.detail.dibayar) }}
                                            </td>
                                            <td>
                                                IDR {{ currencyFormat(transaksiDetail.detail.dibayar * transaksiDetail.detail.kurs_usd) }}
                                            </td>
                                        </tr> -->
                                        <!-- <tr>
                                            <th colspan="2" style="text-align:right">Dibayar</th>
                                            <th>
                                                Rp. {{ currencyFormat(transaksiDetail.detail.dibayar) }}
                                            </th>
                                        </tr>
                                        <tr>
                                            <th style="text-align:right" colspan="2">Sisa Tagihan</th>
                                            <th>Rp. {{ currencyFormat(transaksiDetail.detail.outstanding) }}</th>
                                        </tr> -->
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 text-center">
                    <vc-date-picker v-if="setPenerimaan == true" v-model="tanggal_terima" :input-props='{class: "form-control",placeholder: "Masukkan tanggal penerimaan",style:"display:inline;width:15%;"}'/>
                    <button v-if="setPacking == true" @click="submitTransaksi()" class="btn btn-light"> <i class="fa fa-check"></i> Submit Pemesanan</button>
                    <button v-if="setPenerimaan == true" @click="submitPenerimaan()" class="btn btn-success"> <i class="fas fa-truck"></i> Update Penerimaan</button>
                    <button @click="goBack()" class="btn btn-danger">Kembali</button>
                </div>
            </div>
        </div>
        </section>
    </div>
</template>
<style>
td {
    height: 30px;
}
</style>

<script>
import Vue from 'vue'
import VCalendar from 'v-calendar';
import {IMaskDirective} from 'vue-imask';

Vue.use(VCalendar, {
  componentPrefix: 'vc',
  locales: {
    'pt-PT': {
      firstDayOfWeek: 1,
      masks: {
        L: 'YYYY-MM-DD',
        input : 'YYYY-MM-DD'
      }
    }
  }
});

export default {
    data() {
        return {
            transaksiDetail : {
                detail : {
                    nomor_transaksi : '',
                    // kode_produk : '',
                    // qty_total : '',
                    // nama_satuan : '',
                    // harga_jual : 1000,
                    // deskripsi : '',
                },
                produkList : []
            },
            mask: {
                mask: Number,
                thousandsSeparator: '.',
                normalizeZeros: false,
            },
            id_transaksi : '',
            tipe_transaksi : '',
            jenis_transaksi : '',
            url : '',
            setPengiriman : false,
            setPenerimaan : false,
            setFaktur : false,
            setPacking : false,
            tanggal_pengiriman: '',
            tanggal_terima: '',
            produkDiterima : [],
            nomor_pengiriman : '',
            kurs_usd : 0,
            bodyRender : true,
            pajak : 0,
            dibayar: '0',
            dibayar_idr : '0',
            done : false,
            siteUrl : window.location.href.substr(0, window.location.href.indexOf('#')),
            disableIdr : true,
            tipe : (this.$route.params.tipe_transaksi == 'pemesanan' || this.$route.params.tipe_transaksi == 'packing') ? 'transaksi' : 'progress'
        }
    },
    mounted() {
        this.id_transaksi = this.$route.params.id_transaksi;
        this.init();
    },
    methods: {
        init: function() {
            // get Produk Detail
            this.$root.is_loading = true;
            if(this.tipe == 'transaksi') {
                this.$http.post("Transaksi/getTransaksiDetail/"+this.id_transaksi).then(result => {
                    if(result.data.code == '00') {
                        alert('failed get Detail')
                    }
                    else {
                        this.setPenerimaan = false
                        this.setPengiriman = false
                        this.setFaktur = false
                        this.setPacking = false
                        this.done = false
                        this.transaksiDetail = result.data.detail
                        this.jenis_transaksi = result.data.detail.detail.jenis_transaksi
                        this.tipe_transaksi = result.data.detail.detail.tipe_transaksi+" #"+result.data.detail.detail.nomor_transaksi
                        this.url = result.data.detail.detail.tipe_transaksi+"-"+this.jenis_transaksi
                        if(this.transaksiDetail.detail.tipe_transaksi == 'pemesanan'){
                            this.setPacking = true
                        }else if(this.transaksiDetail.detail.tipe_transaksi == 'packing'){
                            this.setPengiriman = true
                        }else if(this.transaksiDetail.detail.tipe_transaksi == 'pengiriman'){
                            this.setPenerimaan = true
                        }else if(this.transaksiDetail.detail.tipe_transaksi == 'faktur') {
                            this.setFaktur = true
                        }else if(this.transaksiDetail.detail.tipe_transaksi == 'selesai'){
                            this.done = true
                        }

                        let that = this
                        this.transaksiDetail.produkList.forEach(function(item, index){
                            if(item.status_terima == 1){
                                that.transaksiDetail.produkList[index].status_terima = true
                            }else{
                                that.transaksiDetail.produkList[index].status_terima = false
                            }
                            that.transaksiDetail.produkList[index].harga_satuan_idr = item.harga_satuan * that.transaksiDetail.detail.kurs_usd
                            that.transaksiDetail.produkList[index].harga_total_idr = 0
                            that.transaksiDetail.produkList[index].diterima = item.qty_diterima
                        });
                    }
                    this.$root.is_loading = false;
                }, error => {
                    console.log('gk ok')
                    context.errors = errors;
                    this.$root.is_loading = false;
                });
            }else if(this.tipe == 'progress') {
                this.$http.post("Transaksi/getTransaksiProgressDetail/"+this.id_transaksi).then(result => {
                    if(result.data.code == '00') {
                        alert('failed get Detail')
                    }
                    else {
                        this.setPenerimaan = false
                        this.setPengiriman = false
                        this.setFaktur = false
                        this.setPacking = false
                        this.transaksiDetail = result.data.detail
                        this.jenis_transaksi = result.data.detail.detail.jenis_progress
                        this.tipe_transaksi = result.data.detail.detail.status_progress+" #"+result.data.detail.detail.nomor_invoice
                        this.url = result.data.detail.detail.tipe_transaksi+"-"+this.jenis_transaksi
                        if(this.transaksiDetail.detail.status_progress == 'pemesanan'){
                            this.setPacking = true
                        }else if(this.transaksiDetail.detail.status_progress == 'packing'){
                            this.setPengiriman = true
                        }else if(this.transaksiDetail.detail.status_progress == 'pengiriman'){
                            this.setPenerimaan = true
                        }else if(this.transaksiDetail.detail.status_progress == 'faktur') {
                            this.setFaktur = true
                        }else if(this.transaksiDetail.detail.status_progress == 'selesai'){
                            this.done = true
                        }

                        let that = this
                        this.transaksiDetail.produkList.forEach(function(item, index){
                            if(item.status_produk == 1){
                                that.transaksiDetail.produkList[index].status_terima = true
                            }else{
                                that.transaksiDetail.produkList[index].status_terima = false
                            }
                            that.transaksiDetail.produkList[index].harga_satuan_idr = item.harga_satuan * that.transaksiDetail.detail.kurs_usd
                            that.transaksiDetail.produkList[index].harga_total_idr = 0
                            that.transaksiDetail.produkList[index].diterima = item.qty_diterima
                        });
                    }
                    this.$root.is_loading = !this.$root.is_loading;
                }, error => {
                    this.$root.is_loading = !this.$root.is_loading;
                    console.log('gk ok')
                    context.errors = errors;
                });
            }
        },
        currencyFormat: function(val){
            return this.$parent.currencyFormat(val)
        },
        MoneyCallback(x) {
            return x.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        goTo: function(paths) {
            this.$router.replace({ path : paths })
            var $path = window.location.href.split('/');
            this.isActive = this.$route.path;
            // this.$router.go();
        },
        goBack() {
            var back = ''
            if(this.transaksiDetail.detail.tipe_transaksi == 'pemesanan') {
                back = '/penjualan/list/pemesanan-penjualan'
            }else if(this.transaksiDetail.detail.tipe_transaksi == 'packing') {
                back = '/penjualan/list/packing-penjualan'
            }else if(this.transaksiDetail.detail.tipe_transaksi == 'done') {
                back = '/penjualan/list/packing-penjualan'
            }else if(this.transaksiDetail.detail.status_progress == 'pengiriman') {
                back = '/penjualan/list/pengiriman-penjualan'
            }else if(this.transaksiDetail.detail.status_progress == 'faktur'){
                back = '/penjualan/list/faktur-penjualan'
            }else if(this.transaksiDetail.detail.status_progress == 'selesai') {
                back = '/penjualan/list/selesai-penjualan'
            }
            if(this.$parent.last_route == window.localStorage.getItem('last_route')){
                back = this.$parent.last_route
            }
            this.$router.replace({ path : back })
            var $path = window.location.href.split('/');
            this.isActive = this.$route.path;
        },
        submitPengiriman() {
            if(this.tanggal_pengiriman == ''){
                this.$parent.toastr = {
                    title : 'Warning',
                    message: 'Masukkan tanggal pengiriman !',
                    type : 'warning'
                }
                return false
            }

            if(!confirm('Setelah pengiriman kamu tidak bisa mengubah data transaksi ini lagi !')){
                return false
            }

            var formsub = new FormData()
            formsub.append('tanggal_kirim',this.formatDate(this.tanggal_pengiriman))
            formsub.append('nomor_pengiriman',this.nomor_pengiriman);
            formsub.append('jenis_transaksi', this.jenis_transaksi)
            this.$http.post("Transaksi/updatePengiriman/"+this.id_transaksi, formsub).then(result => {
                console.log(result);
                if(result.data.code == '01') {
                    this.$parent.toastr = {
                        title : 'Success',
                        message: 'Transaksi berhasil di update !',
                        type : 'success'
                    }
                    this.$nextTick(function(){
                        this.init()
                    });
                }
                else {
                    this.$parent.toastr = {
                        title : 'Error',
                        message: 'Failed update pengiriman !',
                        type : 'error'
                    }
                }
			}, error => {
				console.log('gk ok')
					context.errors = errors;
			});
        },
        submitTransaksi() {
            if(!confirm('Setelah submit kamu tidak bisa mengubah data transaksi ini lagi !')){
                return false
            }

            var formsub = new FormData()
            this.$http.post("Transaksi/updateToPacking/"+this.id_transaksi, formsub).then(result => {
                console.log(result);
                if(result.data.code == '01') {
                    this.$parent.toastr = {
                        title : 'Success',
                        message: 'Transaksi berhasil diupdate !',
                        type : 'success'
                    }
                    this.$nextTick(function(){
                        this.init();
                    });
                }
                else {
                    this.$parent.toastr = {
                        title : 'Error',
                        message: 'Transaksi gagal diupdate !',
                        type : 'error'
                    }
                }
			}, error => {
				console.log('gk ok')
					context.errors = errors;
			});
        },
        submitPenerimaan() {
            if(this.tanggal_terima == ''){
                this.$parent.toastr = {
                    title : 'Warning',
                    message: 'Masukkan tanggal penerimaan !',
                    type : 'warning'
                }
                return false
            }

            if(!confirm('Pastikan barang dan jumlah yang diterima sudah sesuai dengan data pada sistem !')){
                return false
            }

            var formsub = new FormData()
            var objThis = this

            let change = true
            this.transaksiDetail.produkList.forEach(function(item,index){
                var count = item.qty - item.qty_diterima
                if(count > 0){
                    change = false
                }
            })

            formsub.append('change',change);
            formsub.append('jenis_transaksi',this.jenis_transaksi);
            formsub.append('jenis_progress',this.jenis_transaksi);
            $.map(objThis.transaksiDetail.produkList, function(value,index){
                    formsub.append('dataProduk['+index+'][id_produk]', value.id_produk);
                    formsub.append('dataProduk['+index+'][status_terima]', value.status_terima);
                    formsub.append('dataProduk['+index+'][qty_terima]', value.qty_diterima);
                    formsub.append('dataProduk['+index+'][diterima_sebelumnya]', value.diterima)
            });

            formsub.append('tanggal_terima',this.formatDate(this.tanggal_terima))

            this.$http.post("Transaksi/updatePenerimaanProgress/"+this.id_transaksi, formsub).then(result => {
                if(result.data.code == '01') {
                    this.$parent.toastr = {
                        title : 'Success',
                        message: 'Transaksi berhasil di update !',
                        type : 'success'
                    }
                    this.$nextTick(function(){
                        this.init();
                    });
                }
                else {
                    this.$parent.toastr = {
                        title : 'Error',
                        message: 'Failed update pengiriman !',
                        type : 'error'
                    }
                }
			}, error => {
				console.log('gk ok')
					context.errors = errors;
			});
        },
        submitPembayaran: function() {
            if(this.total_semua > 0){
                this.$parent.toastr = {
                    title : 'Warning',
                    message: 'Sisa tagihan harus 0 atau kurang !',
                    type : 'warning'
                }
                return false
            }

            if(!confirm('Pastikan jumlah pembayaran sudah sesuai !')){
                return false
            }

            var formsub = new FormData()
            var objThis = this

            formsub.append('dibayar',this.dibayar);
            formsub.append('kurs_usd',this.kurs_usd);
            formsub.append('total_harga',this.total_tagihan);
            formsub.append('outstanding',(this.total_semua));
            formsub.append('pajak',this.pajak);
            formsub.append('jenis_transaksi',this.jenis_transaksi);

            $.map(objThis.transaksiDetail.produkList, function(value,index){
                    formsub.append('dataProduk['+index+'][id_produk]', value.id_produk);
                    formsub.append('dataProduk['+index+'][id_transaksi_produk]', value.id_transaksi_produk);
                    formsub.append('dataProduk['+index+'][harga_satuan]', value.harga_satuan);
                    formsub.append('dataProduk['+index+'][harga_total]', value.harga_total);
            });

            this.$http.post("Transaksi/updatePembayaranProgress/"+this.id_transaksi, formsub).then(result => {
                if(result.data.code == '01') {
                    this.$parent.toastr = {
                        title : 'Success',
                        message: 'Transaksi berhasil di update !',
                        type : 'success'
                    }
                    this.$nextTick(function(){
                        this.init();
                    });
                }
                else {
                    this.$parent.toastr = {
                        title : 'Error',
                        message: 'Transaksi ini Sudah Dibayar !',
                        type : 'error'
                    }
                }
			}, error => {
				console.log('gk ok')
					context.errors = errors;
            });

        },
        formatDate(date) {
            var d = new Date(date),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2) month = '0' + month;
            if (day.length < 2) day = '0' + day;

            return [year, month, day].join('-');
        },
        produce(index) {
            if(!confirm('Yakin ingin produksi ?')){
                return false
            }
            var formProd = new FormData()
            formProd.append('qty_produce',this.transaksiDetail.produkList[index].qty_produce);
            formProd.append('id_produk', this.transaksiDetail.produkList[index].id_produk);
            this.$http.post("Produk/prosesProduksi/"+this.transaksiDetail.produkList[index].id_produk, formProd).then(result => {
                if(result.data.code == '01') {
                    this.$parent.toastr = {
                        title : 'Success',
                        message: 'Produksi berhasil !',
                        type : 'success'
                    }
                    this.$nextTick(function (){
                        this.init();
                    })
                }
                else {
                    this.$parent.toastr = {
                        title : 'Error',
                        message: 'Produksi gagal !',
                        type : 'error'
                    }
                }
			}, error => {
				console.log('gk ok')
					context.errors = errors;
            });
        },
        countHarga: function(index) {
            if(this.transaksiDetail.produkList[index].harga_satuan == 0){
                this.transaksiDetail.produkList[index].harga_satuan = (this.transaksiDetail.produkList[index].harga_total / this.transaksiDetail.produkList[index].qty_send).toFixed(2);
            }else{
                this.transaksiDetail.produkList[index].harga_total = (this.transaksiDetail.produkList[index].harga_satuan * this.transaksiDetail.produkList[index].qty_send).toFixed(2);
                this.transaksiDetail.produkList[index].harga_satuan_idr = (this.transaksiDetail.produkList[index].harga_satuan * this.kurs_usd).toFixed(2);
                this.transaksiDetail.produkList[index].harga_total_idr = (this.transaksiDetail.produkList[index].harga_satuan_idr * this.transaksiDetail.produkList[index].qty_send).toFixed(2);
            }
        },
        countHargaUsd: function(index) {
            if(this.transaksiDetail.produkList[index].harga_satuan_idr == 0){
                this.transaksiDetail.produkList[index].harga_satuan_idr = (this.transaksiDetail.produkList[index].harga_total_idr / this.transaksiDetail.produkList[index].qty_send).toFixed(2);
            }else{
                this.transaksiDetail.produkList[index].harga_satuan = (this.transaksiDetail.produkList[index].harga_satuan_idr / this.kurs_usd).toFixed(2);
                this.transaksiDetail.produkList[index].harga_total = (this.transaksiDetail.produkList[index].harga_satuan * this.transaksiDetail.produkList[index].qty_send).toFixed(2);
                this.transaksiDetail.produkList[index].harga_total_idr = (this.transaksiDetail.produkList[index].harga_satuan_idr * this.transaksiDetail.produkList[index].qty_send).toFixed(2);
            }
        },
        countSatuan: function(index) {
            this.transaksiDetail.produkList[index].harga_satuan = (this.transaksiDetail.produkList[index].harga_total / this.transaksiDetail.produkList[index].qty_send).toFixed(2);
            this.transaksiDetail.produkList[index].harga_satuan_idr = (this.transaksiDetail.produkList[index].harga_satuan * this.kurs_usd).toFixed(2);
            this.transaksiDetail.produkList[index].harga_total_idr = (this.transaksiDetail.produkList[index].harga_satuan_idr * this.transaksiDetail.produkList[index].qty_send).toFixed(2)
        },
        countKurs: function() {
            let that = this
            this.transaksiDetail.produkList.forEach(function(item,index){
                that.transaksiDetail.produkList[index].harga_satuan_idr = (item.harga_satuan * that.kurs_usd).toFixed(2);
                that.transaksiDetail.produkList[index].harga_total_idr =  (item.harga_total * that.kurs_usd).toFixed(2);
            })
            this.getDibayarIdr();
            this.bodyRender = false
            this.$nextTick(function(){
                this.bodyRender = true
            })
        },
        countIdr: function(index) {
            this.transaksiDetail.produkList[index].harga_satuan_idr = (this.transaksiDetail.produkList[index].harga_total_idr / this.transaksiDetail.produkList[index].qty_send).toFixed(2)
            this.transaksiDetail.produkList[index].harga_satuan = (this.transaksiDetail.produkList[index].harga_satuan_idr / this.kurs_usd).toFixed(2)
            this.transaksiDetail.produkList[index].harga_total = (this.transaksiDetail.produkList[index].harga_satuan * this.transaksiDetail.produkList[index].qty_send).toFixed(2)
        },
        getDibayarIdr: function() {
            this.dibayar_idr = (this.dibayar * this.kurs_usd).toFixed(2);
        },
        getDibayarUsd: function() {
            this.dibayar = (this.dibayar_idr/this.kurs_usd).toFixed(2);
        },
        deleteTransaksi: function(id_transaksi) {
            if(!confirm('Apakah kamu yakin mau menghapus transaksi ini?')){
                return false
            }
            this.$http.get('Transaksi/deleteTransaksi/'+id_transaksi).then(result => {
                if(result.data.code == '00') {
                    alert('failed delete transaksi')
                }else {
                    this.$parent.toastr = {
                        title : 'Success',
                        message: 'Transaksi '+ this.transaksiDetail.detail.nomor_transaksi +' Berhasil Dihapus',
                        type : 'success'
                    }
                    this.goBack();
                }
            }, error => {
                this.$root.is_loading = !this.$root.is_loading;
				console.log('gk ok')
				context.errors = errors;
            })
        },
        deleteTransaksiProgress: function(id_transaksi) {
            if(!confirm('Apakah kamu yakin mau menghapus transaksi ini?')){
                return false
            }
            this.$http.get('Transaksi/deleteTransaksiProgress/'+id_transaksi).then(result => {
                if(result.data.code == '00') {
                    alert('failed delete transaksi')
                }else {
                    this.$parent.toastr = {
                        title : 'Success',
                        message: 'Transaksi Nomor Pengiriman '+ this.transaksiDetail.detail.nomor_pengiriman +' Berhasil Dihapus',
                        type : 'success'
                    }
                    this.goBack();
                }
            }, error => {
                this.$root.is_loading = !this.$root.is_loading;
				console.log('gk ok')
				context.errors = errors;
            })
        },
        statusPackCallback: function(status) {
            if(status == 1){
                return '<span style="color:green;">Produk Telah di Pack Semua</span>'
            }else {
                return '<span style="color:orange;">Produk Belum / Belum Semua di Pack</span>'
            }
        },
        returnItem: function(id_transaksi_produk,id_transaksi_progress) {
            var qty = prompt('Masukkan Jumlah Qty yang di return');
            if(qty == null)
            {
              return false;
            }
            var formData = new FormData();
            formData.append('qty',qty);

            this.$http.post('Transaksi/returnItem/'+id_transaksi_produk+'/'+id_transaksi_progress,formData).then( result => {
                if(result.data.code == '01') {
                    this.$parent.toastr = {
                        title : 'Success',
                        message: 'Produk berhasil dikembalikan !',
                        type : 'success'
                    }
                    this.$nextTick(function(){
                        this.init()
                    });
                }else {
                    this.$parent.toastr = {
                        title : 'Error',
                        message: 'Produk gagal di kembalikan !',
                        type : 'error'
                    }
                }
            })
        }
    },
    directives: {
      imask: IMaskDirective
    },
    components: {

    },
    watch: {
        'kurs_usd' : function() {
            if(this.kurs_usd <= 0){
                this.disableIdr = true
            }else if(this.kurs_usd > 0){
                this.disableIdr = false
            }
        }
    },
    computed: {
        total_semua : function() {
            var totals = 0;
            this.transaksiDetail.produkList.forEach(function(item, index){
                totals = parseFloat(item.harga_total) + totals
            })
            console.log(totals)
            var bayar = this.dibayar
            if(bayar == ''){
                bayar = 0
            }
            var pajak = (this.pajak/100) * totals
            if(pajak == ''){
                pajak = 0
            }
            return (totals - parseFloat(bayar) + pajak).toFixed(2)
        },
        total_semua_idr : function() {
            return this.total_semua * this.kurs_usd
        },
        total_tagihan : function() {
            var totals = 0;
            this.transaksiDetail.produkList.forEach(function(item, index){
                totals = parseFloat(item.harga_total) + totals
            })
            var pajak = (this.pajak/100) * totals
            if(pajak == ''){
                pajak = 0
            }
            return (totals + pajak).toFixed(2)
        },
        total_tagihan_idr : function() {
            return this.total_tagihan * this.kurs_usd
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/components/penjualan/TransaksiDetail.vue